import { usePermission } from "../hooks/usePermission";

export function canSubmitNotes() {
  return usePermission("dealerNotesSubmit");
}

export function canViewNotes() {
  return usePermission("dealerNotesView");
}
